import {Offering, StaticComponent, StaticComponentInstance, StaticOfferings} from './static-form.types'
import {ComponentRef, Injectable, ViewContainerRef} from '@angular/core'
import {InstallLampsStaticFormComponent} from '../job-request-static-forms/install-lamps/install-lamps-static-form.component'
import {CatDoorInstallationStaticFormComponent} from '../job-request-static-forms/cat-door-installation/cat-door-installation-static-form.component'
import {RenewableEnergyConsultingFormComponent} from '../job-request-static-forms/renewable-energy-consulting/renewable-energy-consulting-form.component'
import {LawnMaintenanceStaticFormComponent} from '../job-request-static-forms/lawn-maintenance/lawn-maintenance-static-form.component'
import {LawnMowingStaticFormComponent} from '../job-request-static-forms/lawn-mowing/lawn-mowing-static-form.component'
import {TreeCuttingStaticFormComponent} from '../job-request-static-forms/tree-cutting/tree-cutting-static-form.component'
import {HedgeTrimmingStaticFormComponent} from '../job-request-static-forms/hedge-trimming/hedge-trimming-static-form.component'
import {BoilerDescalingStaticFormComponent} from '../job-request-static-forms/boiler-descaling/boiler-descaling-static-form.component'
import {LayingParquetStaticFormComponent} from '../job-request-static-forms/laying-parquet/laying-parquet-static-form.component'
import {ParquetMaintenanceStaticFormComponent} from '../job-request-static-forms/parquet-maintenance/parquet-maintenance-static-form.component'
import {OfferingType} from '../../../../../../__generated__/types'
import {SolarInstallationStaticFormComponent} from '../job-request-static-forms/solar-installation/solar-installation-static-form.component'

@Injectable({
  providedIn: 'root',
})
export class StaticFormService {
  public renderStaticFormComponent(
    viewContainerRef: ViewContainerRef,
    offering: Offering,
  ): ComponentRef<StaticComponentInstance> | undefined {
    const staticFormComponent = resolveStaticFormComponent(offering.id)
    if (staticFormComponent) {
      return viewContainerRef.createComponent(staticFormComponent)
    }
  }
}

export function resolveStaticFormForPriceRangeOffering(offering: {id: string; type: OfferingType}) {
  // when an offering is NOT price range, a dynamic form defined in the CMS is rendered
  if (offering.type !== 'PRICE_RANGE') {
    return undefined
  } else {
    // for price range offering, a static form is rendered and allows to calculate prices
    return resolveStaticFormComponent(offering.id)
  }
}

export function resolveStaticFormComponent(offeringId: string): StaticComponent | undefined {
  switch (offeringId) {
    case StaticOfferings.LampInstallation:
      return InstallLampsStaticFormComponent
    case StaticOfferings.CatDoorInstallation:
      return CatDoorInstallationStaticFormComponent
    case StaticOfferings.RenewableEnergyConsulting:
      return RenewableEnergyConsultingFormComponent
    case StaticOfferings.LawnMaintenance:
    case StaticOfferings.LawnScarifying:
      // Lawn scarifying is an alias offering for Lawn Maintenance
      return LawnMaintenanceStaticFormComponent
    case StaticOfferings.LawnMowing:
      return LawnMowingStaticFormComponent
    case StaticOfferings.TreeCutting:
      return TreeCuttingStaticFormComponent
    case StaticOfferings.HedgeTrimming:
      return HedgeTrimmingStaticFormComponent
    case StaticOfferings.BoilerDescaling:
      return BoilerDescalingStaticFormComponent
    case StaticOfferings.LayingParquet:
      return LayingParquetStaticFormComponent
    case StaticOfferings.ParquetMaintenance:
      return ParquetMaintenanceStaticFormComponent
    case StaticOfferings.SolarInstallation:
      return SolarInstallationStaticFormComponent
    default:
      return undefined
  }
}
